module.exports = __webpack_public_path__ + "static/media/postcard8.39f074e9.jpg";